import { Box, TextField, Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { PutAPI } from "../../Components/Backend/PutAPI";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import PageTitle from "../../components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import InputAdornment from "@mui/material/InputAdornment";
import ListIcon from "@mui/icons-material/List";

const GrupoAlterar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(3); //Cadastro de Grupos
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const { id } = useParams();
  const apiAxios = APIAxios();
  const navigate = useNavigate();
  const [modulos, setModulos] = useState([]);

  const [formData, setFormData] = useState({
    id: "",
    nome: "",
  });

  //Busca Grupos no backend
  const buscaGrupos = async () => {
    setLoading(true);
    const response = await GetAPI(apiAxios, "/grupos");
    setLoading(false);

    if (response.success) {
      setModulos(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  useEffect(() => {
    buscarPerfil();
    buscaGrupos();
  }, []);

  const buscarPerfil = async () => {
    setLoading(true);
    const response = await GetAPI(apiAxios, `/grupo/${id}`);
    setLoading(false);

    if (response.success) {
      setFormData(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar perfil.");
    }
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: typeof valor === "string" ? valor.toUpperCase() : valor,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const registro = {
      id: formData.id,
      idEmpresa: formData.idEmpresa,
      nome: formData.nome,
    };

    setLoading(true);
    const response = await PutAPI(apiAxios, "/grupo", registro);
    setLoading(false);

    if (response.success) {
      setFormData(response.data);
      setAvisoSucesso("Perfil do grupo atualizado com sucesso!");
    } else {
      setAvisoErro(
        response.errorMessage || "Erro ao atualizar perfil do grupo."
      );
    }
  };

  const handleVoltar = () => {
    navigate("/grupos");
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Alterar Grupo"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          justifyContent: "center",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Descrição */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Descrição:"
                variant="outlined"
                value={formData.nome}
                onChange={(e) => handleChange(e, 50)}
                name="nome"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ListIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865", xs: 12, md: 4 }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>

              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{
                  backgroundColor: "#1a3865",
                  marginLeft: 2,
                  xs: 12,
                  md: 4,
                }}
                type="submit"
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default GrupoAlterar;
